import { z } from "zod";
import { runStatusDegradedReasons, uiPartSupportSchema } from "./agent-ui-parts.js";
// The request and the stored-status answer of the agent run route (CHT-715). The route itself is described in
// `@lafayette/api-contract` (`AGENT_RUN_ROUTE`); the schemas live here because the mobile client and the API both parse them.
/** The most characters of one customer message. A longer one is a 400. */
export const AGENT_RUN_MESSAGE_MAX_CHARS = 2_000;
/**
 * The body of `POST /customer/agent/runs`. Strict. The customer, the conversation and the lease are NEVER in it: the server
 * finds the customer's own conversation. `uiParts` declares the UI part versions that the client can render (version
 * negotiation, `agent-ui-parts.ts`); absent means none, so the answer is text and the terminal run-status only.
 */
export const agentRunRequestSchema = z.strictObject({
    message: z
        .string()
        .min(1)
        .max(AGENT_RUN_MESSAGE_MAX_CHARS)
        .refine((value) => value.trim() !== "", { message: "the message is empty" }),
    uiParts: uiPartSupportSchema.optional(),
});
/**
 * What a request with an old Idempotency-Key gets once its run has ended: the stored status, as JSON (no text replay in
 * Phase 4). A run that is still running answers 409 `agent_run_in_progress` instead.
 */
export const agentRunStatusViewSchema = z.strictObject({
    runId: z.string().regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu),
    status: z.enum(["COMPLETED", "DEGRADED", "CANCELLED", "FENCED", "FAILED"]),
    degradedReason: z.enum(runStatusDegradedReasons).nullable(),
    endedAt: z.iso.datetime(),
});
